import React, { useEffect, useState } from 'react';
import Summary from './Summary';
import { getQuery } from 'utils/queryUtils';
import { reportOpenQrCode } from 'analytics/reporters';
import { AppRoutes } from 'routes';
import { useSceneHandler } from 'contexts/sceneHandler';
import { getVpcSource } from 'analytics-api/insights/utils';
import { useHistory } from 'react-router-dom';
import { DesignSourceEnum } from '@insights/insights-data-provider';
import { useQuery } from '@tanstack/react-query';

const SummaryConfigurationLoader = ({ match }: any) => {
  const vpcCode = match.params.vpcCode || '';
  const [showBackButton, setShowBackButton] = useState(true);
  const { sourceValue, validSource, fromQr } = getVpcSource(getQuery());
  const { loadVpcScene } = useSceneHandler();
  const history = useHistory();

  useEffect(() => {
    if (fromQr) reportOpenQrCode({ designCode: vpcCode });
  }, [vpcCode, fromQr]);

  const loadFn = async () => {
    if (vpcCode) {
      const source = validSource ? sourceValue : DesignSourceEnum.clipboard;
      // Silently loads without dispatching vpc ducks
      const scene = await loadVpcScene(vpcCode, source, { silent: true }).then(scene =>
        // Load entities - needed for summary page
        scene?.init()
      );

      if (!scene) {
        return history.push(AppRoutes.HOME);
      }

      if (scene.legacy) {
        setShowBackButton(false);
      }
    }

    return null;
  };

  const { isLoading, error } = useQuery({
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    queryKey: ['configurationLoader'],
    queryFn: loadFn
  });

  if (isLoading) {
    return null;
  }

  if (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    return null;
  }

  return (
    <Summary
      fromConfigurationLoader
      hideBackButton={!showBackButton}
      backButtonTarget={`${AppRoutes.PLANNER}?vpc=${vpcCode}`}
    />
  );
};

export default SummaryConfigurationLoader;
